import { clientFetcher } from "./client-fetcher";

export const deleteCurrentUser =
  !process.env.NEXT_PUBLIC_CONFIGURATION ||
  process.env.NEXT_PUBLIC_CONFIGURATION === "staging"
    ? async (): Promise<void> => {
        return await clientFetcher.delete("/users/me");
      }
    : async (): Promise<void> => {
        console.warn("deleteCurrentUser is disabled in production");
      };
